import * as React from 'react'
import { createRoot } from 'react-dom/client'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom'
import App from './app'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfirmProvider } from '@/modules/shared/context/ConfirmContext'
import { RouterBridge } from 'app/navigation/RouterBridge'
import { TaskSyncHost } from '@/modules/shared/components/TaskSyncHost'


import './assets/styles'
import './tailwind.css'
import './assets/et/et-styles.css'
import { AuthProvider } from './auth-provider'
import { PrintPreviewModal } from './modules/printouts/components/PrintPreviewModal'
import { LocalizeProvider } from './modules/shared/context/localize/LocalizeContext'
import { initCookieConsent, CookieReminderBubble } from './modules/legal'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient()

// Root layout — runs under the data router so descendant hooks
// (`useBlocker`, `unstable_usePrompt`) work. Descendant `<Routes>` trees in
// AppRoutes/ProtectedAppRoutes/modules still match normally.
function RootLayout() {
  React.useEffect(() => {
    initCookieConsent()
  }, [])
  return (
    <ConfirmProvider>
      <RouterBridge />
      {/* One task sync loop for the whole app — see TaskSyncHost. */}
      <TaskSyncHost />
      <App />
      <PrintPreviewModal />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <Outlet />
      <CookieReminderBubble />
      {/* TODO: <LegalFooter /> — znaleźć właściwe miejsce w layoucie */}
    </ConfirmProvider>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="*" element={<RootLayout />} />),
)

const root = createRoot(document.getElementById('root'))

root.render(
  // <React.StrictMode>
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      {/* Jeden dostawca tłumaczeń na cały korzeń: `useLocalize` wołają też
          komponenty montowane poza drzewem tras (np. `MessagePresenter`). */}
      <LocalizeProvider>
        <RouterProvider router={router} />
      </LocalizeProvider>
    </QueryClientProvider>
  </AuthProvider>,
  // </React.StrictMode>
)
